import { put, takeLatest } from "redux-saga/effects";
import {
  requestRecordPaymentList,
  createRecordPayment,
  editRecordPayment,
  createStatusInvoice,
  updateUTRDetails,
  requestInvoiceDueKpiList,
  requestRecievedSecurityDepositList
} from "services/acclgl/client-Statement/recordPayment";
import {
  fetchrecordPaymentListRequest,
  fetchrecordPaymentListSuccess,
  fetchrecordPaymentListFailure,
  createrecordPaymentRequest,
  createrecordPaymentSuccess,
  createrecordPaymentFailure,
  editRecordPaymentRequest,
  editRecordPaymentSuccess,
  editRecordPaymentFaliure,
  invoiceStatusRequest,
  invoiceStatusSuccess,
  invoiceStatusFaliure,
  UTRDetailsRequest,
  UTRDetailsSuccess,
  UTRDetailsFaliure,
  fetchInvoiceKpiListRequest,
  fetchInvoiceKpiListSuccess,
  fetchInvoiceKpiListFailure,
  recievedSecurityDepositListRequest,
  recievedSecurityDepositListSuccess,
  recievedSecurityDepositListFaliure,
} from "redux/reducers/acclgl/clientStatement/recordPayment";

export function* watchrecordPayment() {
  yield takeLatest(fetchrecordPaymentListRequest, fetchrecordpaymentlist);
  yield takeLatest(createrecordPaymentRequest, createrecordpayment);
  yield takeLatest(editRecordPaymentRequest, editrecordpayment);
  yield takeLatest(invoiceStatusRequest, createStatusInvoiceList);
  yield takeLatest(UTRDetailsRequest, UpdateUTRDetailsList);
  yield takeLatest(fetchInvoiceKpiListRequest, fetchInvoiceDueKpilist);
  yield takeLatest(recievedSecurityDepositListRequest, fetchRecievedSecurityDepositList);
}

function* fetchrecordpaymentlist({ payload }) {
  try {
    const response = yield requestRecordPaymentList(payload);
    yield put(fetchrecordPaymentListSuccess(response));
  } catch (error) {
    yield put(
      fetchrecordPaymentListFailure("Failed to get list of Record Payment")
    );
  }
}

function* fetchInvoiceDueKpilist({ payload }) {
  try {
    const response = yield requestInvoiceDueKpiList(payload);
    yield put(fetchInvoiceKpiListSuccess(response));
  } catch (error) {
    yield put(
      fetchInvoiceKpiListFailure("Failed to get kpin list")
      );
    }
  }
function* fetchRecievedSecurityDepositList({ payload }) {
  try {
    const response = yield requestRecievedSecurityDepositList(payload);
    yield put(recievedSecurityDepositListSuccess(response));
  } catch (error) {
    yield put(
      recievedSecurityDepositListFaliure("Failed to get list recieved security Deposit")
    );
  }
}

function* createrecordpayment({ payload }) {
  try {
    const response = yield createRecordPayment(payload);
    yield put(createrecordPaymentSuccess(response.data));
  } catch (error) {
    const message =
      error?.response?.data?.data?.message ||
      "Failed to create Record of Payment";
    yield put(createrecordPaymentFailure(message));
  }
}

function* createStatusInvoiceList({ payload }) {
  try {
    const response = yield createStatusInvoice(payload);
    yield put(invoiceStatusSuccess(response.data));
  } catch (error) {
    const message =
      error?.response?.data?.data?.message ||
      "Failed to create status";
    yield put(invoiceStatusFaliure(message));
  }
}

function* UpdateUTRDetailsList({ payload }) {
  try {
    const response = yield updateUTRDetails(payload);
    yield put(UTRDetailsSuccess(response.data));
  } catch (error) {
    const message =
      error?.response?.data?.data?.message ||
      "Failed to create Utr Details";
    yield put(UTRDetailsFaliure(message));
  }
}


function* editrecordpayment({ payload }) {
  try {
    const response = yield editRecordPayment(payload);
    yield put(editRecordPaymentSuccess(response.data));
  } catch (error) {
    const message =
      error?.response?.data?.data?.message ||
      "Failed to edit Record of Payment";
    yield put(editRecordPaymentFaliure(message));
  }
}
